/* global globalThis */
import React, { createContext, useState, useContext, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';

const SearchQueryContext = createContext();

export function useAutoClearSearchQuery() {
  const { setSearchQuery } = useSearchQuery();

  useEffect(() => {
    setSearchQuery("");

    return () => {
      setSearchQuery("");
    };
  }, []);
}

export function SearchQueryProvider({ children }) {
  const [searchQuery, setSearchQuery] = useState('');
  const [isCourseSubMenuOpen,setIsCourseSubMenuOpen] = useState(true);
  const [isFeedbackModelOpen, setIsFeedbackModelOpen ] = useState(false);
  const [newFlag, setNewFlag] = useState(false);

  useEffect(() => {
    setSearchQuery(""); // Clear on mount
    return () => {
      setSearchQuery(""); // Clear on unmount
    };
  }, [globalThis.location?.pathname]);

  const contextValue = useMemo(
    () => ({
      searchQuery,
      setSearchQuery,
      isCourseSubMenuOpen,
      setIsCourseSubMenuOpen,
      isFeedbackModelOpen,
      setIsFeedbackModelOpen,
      newFlag,
      setNewFlag,
    }),
    [
      searchQuery,
      isCourseSubMenuOpen,
      isFeedbackModelOpen,
      newFlag,
    ]
  );

  return (
    <SearchQueryContext.Provider
      value={contextValue}
    >
      {children}
    </SearchQueryContext.Provider>
  );
}

SearchQueryProvider.propTypes = {
  children: PropTypes.node,
};

export function useSearchQuery() {
  const context = useContext(SearchQueryContext);
  if (!context) {
    throw new Error('useSearchQuery must be used within a SearchQueryProvider');
  }
  return context;
}
